import inview from 'jquery-inview/jquery.inview';

$(function() {
	if ( window.location.hash == '#get-the-facts' ) {
		$('html,body').animate({scrollTop:$(window.location.hash).offset().top - 170}, 50);
	}
	initAjaxParameters();
	queryPosts();
	handleFilters();
});

$.urlParam = function(name) {
	var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
	if (results == null) {
		return null;
	}
	else {
		return decodeURI(results[1]) || 0;
	}
};

let parameters = {};
let postsXhr = null;

function renderPosts( response ) {
	var postsWrapper = $('.posts .items'),
		paginationWrapper = $('.posts .pagination'),
		numberOfPages = Math.max(1, Math.ceil(response.total / response.perPage));

	postsWrapper.html('');

	response.items.forEach(function(item) {
		postsWrapper.append(item);
	});

	paginationWrapper.html('');

	$('.posts .pagination .page:not(.disabled)').on('click', function(e) {
		e.preventDefault();
		parameters.pg = parseInt($(this).attr('data-page'));
		$('.posts .loader').addClass('active');
		queryPosts(true);
		$('html,body').animate({scrollTop:$('.posts').offset().top - 200}, 600);
	});
}


function pushHistory() {
	let url = window.location.href.split('?')[0];// + '?pg=' + parameters.pg;

	if (parameters.cat != '') {
		url = window.location.href.split('?')[0] + '?pg=' + parameters.pg;
	}

	if (parameters.cat) { url += '&cat=' + parameters.cat; }

	window.history.pushState('next', document.title, url);
}


function queryPosts() {

	pushHistory();

	if (postsXhr) { postsXhr.abort(); }

	postsXhr = $.post({
		url : ajax_params.ajaxurl,
		data : parameters,
		dataType : 'json',
		success : function(response) {

			if (response.items.length > 0) {
				renderPosts(response);

				$('.question').on('click', function(e) {
					e.preventDefault();
					$('.question').not($(this)).removeClass('open');
					$(this).toggleClass('open');
					var el = $(this).next('.answer');
					var vis = el.is(":visible");
					//$('.answer').slideUp();
					el[ vis ? "slideUp" : "slideDown"]();
				});
			}
			activateAnimate();
			$('.posts .loader').removeClass('active');

			if ( window.location.hash == '#get-the-facts' ) {
				setTimeout(() => {
					$('html,body').animate({scrollTop:$(window.location.hash).offset().top - 170}, 50);
				}, 200);
				setTimeout(() => {
					history.replaceState(null, null, ' ');
				}, 2000);
			}

		},

		error : function() {
			console.log('Something went wrong!');
		}
	});
}


function initAjaxParameters() {
	parameters.action = 'load_cq_posts';
	parameters.pg = $.urlParam('pg') ? parseInt($.urlParam('pg')) : 1;
	parameters.cat = $.urlParam('cat') ? $.urlParam('cat') : '';
}


function handleFilters() {
	$('.filters .cat >a').on('click', function (e) {//click on category
		e.preventDefault();
		$('.filters .cat >a').not($(this)).removeClass('active');
		$(this).addClass('active');
		parameters.cat = $(this).data('cat');
		parameters.pg = 1;
		queryPosts();
		$('.posts .loader').addClass('active');
	});

}


/* function pagination( c, m ) {
	var current = c,
		last = m,
		delta = 2,
		left = current - delta,
		right = current + delta - 1,
		range = [],
		rangeWithDots = [],
		l;

	for (let i = 1; i <= last; i++) {
		if (i == 1 || i == last || i >= left && i < right) {
			range.push(i);
		}
	}

	for (let i of range) {
		if (l) {
			if (i - l === 2) {
				rangeWithDots.push(l + 1);
			} else if (i - l !== 1) {
				rangeWithDots.push('...');
			}
		}
		rangeWithDots.push(i);
		l = i;
	}

	return rangeWithDots;
} */


function activateAnimate() {
	$( '.inview-animate--fade' ).each( function() {
		const thisInviewElement = $( this );
		thisInviewElement.one( 'inview', function( event, visible ) {
			if ( visible === true ) {
				thisInviewElement.addClass( 'inview-active' );
			}
		});
	});
}
